export default __webpack_public_path__ + "static/media/team_no_record_yet.e1b02add.png";